// Types
import {
  REFERRALS_SUMMARY_REQUEST_START,
  REFERRALS_SUMMARY_REQUEST_SUCCESS,
  REFERRALS_SUMMARY_REQUEST_FAIL,
  REFERRALS_DETAIL_REQUEST_START,
  REFERRALS_DETAIL_REQUEST_SUCCESS,
  REFERRALS_DETAIL_REQUEST_FAIL,
  REFERRALS_DETAIL_RESET,
  REFERRALS_SEARCH_REQUEST_START,
  REFERRALS_SEARCH_REQUEST_SUCCESS,
  REFERRALS_SEARCH_REQUEST_FAIL,
  REFERRALS_SEARCH_RESET,
  REFERRALS_MONTHS_DETAILS_REQUEST_START,
  REFERRALS_MONTHS_DETAILS_REQUEST_SUCCESS,
  REFERRALS_MONTHS_DETAILS_REQUEST_FAIL
} from './types';
import { MonthStatementDataType } from '../../../core/types/GenrateMonthStatements';
// Redux
import { ReferralsSummaryAction } from './actions';
// Constants
import { COMMISSIONS_SUMMARY_VIEW } from '../../../core/utils/Constants/Constants';

type ReferralsSummaryState = {
  details: any,
  searchDetails: any,
  loadingState: string,
  searchLoadingState: string,
  summaryLoadingState: string,
  results: any,
  referralsViewType: string,
  allAffiliatesNumbers: Array<string>
  monthStatements: MonthStatementDataType[] | null
};

const INITIAL_STATE: ReferralsSummaryState = {
  details: null,
  searchDetails: null,
  loadingState: 'UNINITIALISED',
  searchLoadingState: 'UNINITIALISED',
  summaryLoadingState: 'UNINITIALISED',
  referralsViewType: COMMISSIONS_SUMMARY_VIEW,
  allAffiliatesNumbers: [''],
  results: {
    summaries: {
      referrals: 0,
      registrations: 0,
      accounts: 0
    },
    series: [{ "event": { "eventStart": "January", "eventEnd": "January", "eventLabel": "January" }, "fields": [], "order": 0 }, { "event": { "eventStart": "February", "eventEnd": "February", "eventLabel": "February" }, "fields": [], "order": 1 }, { "event": { "eventStart": "March", "eventEnd": "March", "eventLabel": "March" }, "fields": [], "order": 2 }, { "event": { "eventStart": "April", "eventEnd": "April", "eventLabel": "April" }, "fields": [], "order": 3 }, { "event": { "eventStart": "May", "eventEnd": "May", "eventLabel": "May" }, "fields": [], "order": 4 }, { "event": { "eventStart": "June", "eventEnd": "June", "eventLabel": "June" }, "fields": [], "order": 5 }, { "event": { "eventStart": "July", "eventEnd": "July", "eventLabel": "July" }, "fields": [], "order": 6 }, { "event": { "eventStart": "August", "eventEnd": "August", "eventLabel": "August" }, "fields": [], "order": 7 }, { "event": { "eventStart": "September", "eventEnd": "September", "eventLabel": "September" }, "fields": [], "order": 8 }, { "event": { "eventStart": "October", "eventEnd": "October", "eventLabel": "October" }, "fields": [], "order": 9 }, { "event": { "eventStart": "November", "eventEnd": "November", "eventLabel": "November" }, "fields": [], "order": 10 }, { "event": { "eventStart": "December", "eventEnd": "December", "eventLabel": "December" }, "fields": [], "order": 11 }],
    statements: null
  },
  monthStatements: null
};

export const reducer = (
  state = INITIAL_STATE,
  action: ReferralsSummaryAction
): ReferralsSummaryState => {
  switch (action.type) {
    case REFERRALS_SUMMARY_REQUEST_START:
      return {
        ...state,
        summaryLoadingState: 'LOADING'
      };

    case REFERRALS_SUMMARY_REQUEST_SUCCESS:
      return {
        ...state,
        summaryLoadingState: 'LOADED',
        results: action.payload
      };

    case REFERRALS_SUMMARY_REQUEST_FAIL:
      return {
        ...state,
        summaryLoadingState: 'ERROR'
      };

    case REFERRALS_MONTHS_DETAILS_REQUEST_START:
      return {
        ...state,
        loadingState: 'LOADING'
      };

    case REFERRALS_MONTHS_DETAILS_REQUEST_SUCCESS:
      return {
        ...state,
        loadingState: 'LOADED',
        monthStatements: action.payload
      };

    case REFERRALS_MONTHS_DETAILS_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'ERROR'
      };

    case REFERRALS_DETAIL_REQUEST_SUCCESS:
      return {
        ...state,
        details: action.payload?.details,
        referralsViewType: action.payload?.referralsViewType,
        allAffiliatesNumbers: action.payload?.allAffiliatesNumbers,
        loadingState: 'LOADED'
      };

    case REFERRALS_DETAIL_REQUEST_START:
      return {
        ...state,
        details: null,
        loadingState: 'LOADING'
      };

    case REFERRALS_DETAIL_REQUEST_FAIL:
      return {
        ...state,
        details: null,
        loadingState: 'ERROR'
      };

    case REFERRALS_DETAIL_RESET:
      return {
        ...state,
        details: null,
        loadingState: 'LOADED'
      };

    case REFERRALS_SEARCH_REQUEST_START:
      return {
        ...state,
        searchDetails: null,
        searchLoadingState: 'LOADING'
      };

    case REFERRALS_SEARCH_REQUEST_SUCCESS:
      return {
        ...state,
        searchDetails: action.payload,
        searchLoadingState: 'LOADED'
      };

    case REFERRALS_SEARCH_REQUEST_FAIL:
      return {
        ...state,
        searchDetails: null,
        searchLoadingState: 'LOADED'
      };

    case REFERRALS_SEARCH_RESET:
      return {
        ...state,
        searchDetails: null,
        searchLoadingState: 'UNINITIALISED'
      };

    default:
      return state;
  }
};
